import { BillingCompanyConfig } from 'gql-types';

import { AccountRate } from '../enums';

export const LATEST_START_RATE = AccountRate.START_2024_10;
export const LATEST_PRO_RATE = AccountRate.PRO_2024_10;
export const LATEST_PRO_PLUS_RATE = AccountRate.PRO_PLUS_2022_12;

export const INTEGRATION_RATES_SET = new Set([
    AccountRate.INTEGRATION,
    AccountRate.INTEGRATION_WITH_DOCUMENTS,
    AccountRate.FILL_INTEGRATION,
    AccountRate.INTEGRATION_TRIAL,
]);

export const START_RATES_SET = new Set([
    AccountRate.START,
    AccountRate.START_2022_01,
    AccountRate.START_2022_04,
    AccountRate.START_2022_08,
    AccountRate.START_2023_10,
    AccountRate.START_2024_10,
]);

export const PRO_RATES_SET = new Set([
    AccountRate.PRO,
    AccountRate.PRO_2021,
    AccountRate.PRO_2022,
    AccountRate.PRO_2022_04,
    AccountRate.PRO_2022_12,
    AccountRate.PRO_2023_07,
    AccountRate.PRO_2023_10,
    AccountRate.PRO_2024_10,
    AccountRate.PRO_PLUS,
    AccountRate.PRO_PLUS_2022_04,
    AccountRate.PRO_PLUS_2022_12,
]);

export const PRO_TRIALS_SET = new Set([
    AccountRate.PRO_TRIAL,
    AccountRate.PRO_PLUS_TRIAL,
    AccountRate.PRO_PLUS_TRIAL_2022,
    AccountRate.PRO_PLUS_TRIAL_2022_12,
]);

export const UNLIMITED_RATES_SET = new Set([
    AccountRate.PRO,
    AccountRate.PRO_TRIAL,
    AccountRate.PRO_2021,
    AccountRate.PRO_2022,
    AccountRate.PRO_PLUS,
    AccountRate.PRO_PLUS_2022_04,
    AccountRate.PRO_PLUS_2022_12,
    AccountRate.PRO_PLUS_TRIAL,
    AccountRate.ULTIMATE,
    AccountRate.ULTIMATE_2022_12,
]);

export const EXTENDS_RATES_SET = new Set([
    AccountRate.ARCHIVE_SMALL,
    AccountRate.ARCHIVE_BIG,
]);

export const ARCHIVE_RATES_SET = new Set([
    AccountRate.ARCHIVE_SMALL,
    AccountRate.ARCHIVE_BIG,
]);

export const DEFAULT_BILLING_COMPANY_CONFIG: Required<BillingCompanyConfig> = {
    __typename: 'BillingCompanyConfig',
    apiEnabled: false,
    canEnforce2FA: false,
    canManageEmployeeAccess: false,
    externalCommentsEnabled: false,
    internalCommentsEnabled: false,
    internalDocumentsEnabled: false,
    reviewsEnabled: false,
    maxAdditionalFieldsCount: null,
    maxArchiveDocumentsCount: null,
    maxDocumentsCount: null,
    maxEmployeesCount: null,
    maxRequiredFieldsCount: null,
    maxTagsCount: null,
    maxTemplatesCount: null,
    maxVersionsCount: null,
};

export const ALL_FREE_START_PRO_RATES: AccountRate[] = [
    AccountRate.FREE,
    AccountRate.START,
    AccountRate.START_2022_01,
    AccountRate.START_2022_04,
    AccountRate.START_2022_08,
    AccountRate.START_2023_10,
    AccountRate.START_2024_10,
    AccountRate.PRO_2021,
    AccountRate.PRO_2022,
    AccountRate.PRO_2022_01,
    AccountRate.PRO_2022_04,
    AccountRate.PRO_2022_12,
    AccountRate.PRO_2023_07,
    AccountRate.PRO_2023_10,
    AccountRate.PRO_2024_10,
    AccountRate.PRO_PLUS,
    AccountRate.PRO_PLUS_2022_04,
    AccountRate.PRO_PLUS_2022_12,
];

export const ALL_FREE_START_PRO_RATES_EXCEPT_BEZLIM: AccountRate[] = ALL_FREE_START_PRO_RATES.filter(
    (rate) => rate !== AccountRate.PRO,
);
